import React, { useCallback } from 'react';
import { AutocompleteDropdown, Box, Text } from '@common-fe/common-fe';

import { OptionKey } from '@/common/types';

import useGetContactsAndByIdQuery from '../queries/useGetContactsAndById.query';

interface Props {
  contactId?: string ;
  organizationId?: string;
  setContactId: (value: string) => void;
}

const ContactLoginHistoryHeader: React.FC<Props> = ({ contactId, organizationId, setContactId }) => {
  const { contactListOptions, isLoading } = useGetContactsAndByIdQuery({ contactId, organizationId });

  const handleSetContact = useCallback((contactId?: OptionKey) => {
    setContactId( contactId as string);
  }, [setContactId]);

  return (
    <Box data-testId="contact-login-history_page-header" direction="row" align="center" justify="between">
      <Text size="3xl" weight={700}>
        Contacts Authentication History
      </Text>

      <Box width={{ width: '100%', max: '200px' }}>
        <AutocompleteDropdown
          name="contact"
          testId="contact"
          placeholder="Select contact"
          value={contactId as string}
          defaultValue={contactId as string}
          onChange={handleSetContact}
          options={contactListOptions}
          isLoading={isLoading}
          ellipsisMode
          disableFiltering
        />
      </Box>
    </Box>
  );
};

export default ContactLoginHistoryHeader;
